// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/success.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/warning.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/in_progress.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/Spinner-1s-16px.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/headerSortUp.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/headerSortDown.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/headerSort.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/EditForm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/ExclaimForm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/GreyForm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/AddForm.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/CompleteForm.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    min-height: 100%;
    position: relative;
}

input.list-group-item {
    text-align: left;
    width: 100%;
}

.form-control-static {
    height: auto;
    min-height: 34px;
    font-weight: normal;
}

.has-error label.dfRequired,
.has-error legend.dfRequired {
    color: #b94a48;
}

.nested-row.form-group-child {
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.nested-row,
.nested-row.form-group-child .form-group-child {
    margin: 0 !important;
}

.help-button {
    padding: 0 2px;
    font-size: 14px;
}

/*label.dfRequired + .checkbox:only-of-type label:after,
    label.dfRequired + .checkbox:only-of-type label:after,*/
label.dfRequired:after,
legend.dfRequired:after,
[data-val-required] + .checkbox:only-of-type label:after,
[data-val-required] + .checkbox-inline:only-of-type:after {
    position: relative;
    content: "*";
    color: #b94a48;
    font-size: 1.4em;
    font-weight: normal;
    line-height: 0.8ex;
    vertical-align: middle;
}

label.dfRequired + [data-val-required] + .checkbox:only-of-type label:after {
    display: none;
    content: "";
}

.checkbox:only-of-type [type="checkbox"][data-val-required]:before,
.checkbox-inline:only-of-type [type="checkbox"][data-val-required]:before {
    display: none !important;
}
/*TODO: Add required asterisk to form labels instead*/

/*div.dfCompositeControlErrorMessage span{
    display:none;
}*/
div.dfCompositeControlErrorMessage :first-child {
    color: #0000ff;
}

div.child-error .highlight-on-child-error {
    color: #b94a48;
}

.dfCompositControlChildMargin {
    margin-top: 5px;
}

.dfHideBlock {
    display: none;
}

.dfHidden {
    display: none;
}

.masthead {
    width: 100%;
    height: 100px;
    padding: 15px;
    background-image: none;
    background-color: #ffffff;
}

.masthead {
    width: 100%;
    height: 100px;
    padding: 15px;
    background-image: none;
    background-color: #ffffff;
    z-index: 2;
}

.masthead_img_div {
    float: left;
    height: 70px;
    width: auto;
    margin-right: 15px;
}

.masthead img {
    height: 70px;
}

.masthead_title_div {
    float: left;
    height: 70px;
}

.masthead span {
    display: block;
    margin-left: 0;
    color: #444444;
    font-weight: normal;
}

.masthead .agency_name {
    font-size: 30px;
    margin-top: -3px;
}

.masthead .app_name {
    font-size: 24px;
    margin-top: -5px;
}

.form-group-child {
    margin-bottom: 10px;
    /*padding:0;*/
}

/*.form-group .form-group:not(.form-group-child) {
    margin-bottom: 0;
}*/

.dfShowBlock {
    display: block;
}

div.child-error .child-error-message {
    display: block;
    width: 100%;
    text-align: left;
    font-style: italic;
    color: #b94a48;
}

.field-validation-error {
    display: block;
    width: 100%;
    text-align: left;
    font-style: italic;
    font-size: 13px;
    font-weight: 500;
    color: #b94a48;
    margin-top: 3px;
}

/* For null page statuses */
#PageNavigation .list-group-item {
    background-repeat: no-repeat;
    width: 100%;
    text-align: left;
}
a.dfPageLink_NotStarted,
button[type="submit"].dfPageLink_NotStarted,
a.dfPageLink_InProgress,
button[type="submit"].dfPageLink_InProgress,
a.dfPageLink_Invalid,
button[type="submit"].dfPageLink_Invalid,
a.dfPageLink_Complete,
button[type="submit"].dfPageLink_Complete,
a.dfPageLink_Disabled,
button[type="submit"].dfPageLink_Disabled,
a.dfPageLink_Saving,
button[type="submit"].dfPageLink_Saving {
    padding-left: 30px;
    background-repeat: no-repeat;
    width: 100%;
    text-align: left;
}

a.dfPageLink_NotStarted,
button[type="submit"].dfPageLink_NotStarted {
    background-position: 4px 3px;
}

a.dfPageLink_Complete,
button[type="submit"].dfPageLink_Complete {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 17px;
    background-position: 7px center;
}

a.dfPageLink_Invalid,
button[type="submit"].dfPageLink_Invalid {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 17px;
    background-position: 7px center;
}

a.dfPageLink_InProgress,
button[type="submit"].dfPageLink_InProgress {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 10px;
    background-position: 11px center;
    background-color: #ddd !important;
    color: #444 !important;
    border-color: #bbb !important;
}

a.dfPageLink_Saving,
button[type="submit"].dfPageLink_Saving {
    background-position: 7px center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 18px;
}

.form-control {
    color: #333333;
}

/*.dfGhosted {
    color: #999999;
}*/

/*select.dfHasPlaceholder option[value=""], .placeholder {
    color: #aaaaaa;
}*/

.form-control::-webkit-input-placeholder {
    color: #999999;
    opacity: 1;
}

.form-control::-moz-placeholder {
    color: #999999;
    opacity: 1;
}

.form-control:-ms-input-placeholder {
    color: #999999;
    opacity: 1;
}

.form-control::-ms-input-placeholder {
    color: #999999;
    opacity: 1;
}

.form-control::placeholder {
    color: #999999;
    opacity: 1;
}

#DataSourceTable,
.table-datasource {
    background: #ffffff;
    margin-bottom: 0;
}

#DataSourceTable th,
#DataSourceTable td,
.table-datasource th,
.table-datasource td {
    min-width: 200px;
    padding: 0;
}

#DataSourceTable th .form-control,
.table-datasource th .form-control {
    background: none;
}

#DataSourceTable .btn,
.table-datasource .btn {
    margin: 0;
    width: 100%;
    border-color: transparent;
    border-radius: 0;
}

#DataSourceTable .input-group,
.table-datasource .input-group {
    flex-wrap: nowrap;
}

#DataSourceTable .form-control,
.table-datasource .form-control {
    border-radius: 0;
    border-color: transparent;
    background: none;
}

#DataSourceTable .form-control:focus,
.table-datasource .form-control:focus {
    border-color: dodgerblue;
}

.btn-delete-hovered {
    background: #eeeeee;
}

#DataSourceTable .btn.btn-add-col,
.table-datasource .btn.btn-add-col {
    font-size: 18px;
    padding: 3px;
}

.data-source-preview {
    float: right;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 6px 12px;
    background: #eeeeee;
}

.add-col {
    min-width: 0 !important;
    width: 60px;
}

/* Custom container */
.container-narrow {
    margin: 0 auto;
    max-width: 1140px;
    padding: 20px 30px 15px 30px;
    border: 1px solid #dddddd;
    background: #ffffff;
    border-radius: 8px;
}

.container-narrow > hr {
    margin: 30px 0;
}

/*.DFPageHeadingCnt {
    padding: 15px;
    display: block;
    margin-bottom: 30px;
    border-bottom: solid 1px #dddddd;
     background: #ffffff;
    margin-top: 0;
}*/

/*.DFPageHeading {
    font-size: 16pt;
    font-weight: bold;
    display: block;
    padding-left: 5px;
    padding-bottom:2px;
    margin-bottom:2px;
    margin-top:0;
      border-color: #dddddd;
    margin-left: 0;
    padding-left: 0;
    font-size: 24px;
}*/

.DFPageContent {
    background: #ffffff;
}

.df-page-sub {
    font-size: 12pt;
    color: #606060;
    padding-left: 5px;
    padding-bottom: 15px;
}

.DFPageContent {
    padding: 30px 15px;
    padding-top: 0;
}

.df-page-title {
    display: block;
    margin-top: 4px;
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 20px;
    padding-bottom: 10px;
}

.DFSectionHeading {
    padding-bottom: 15px;
}

.df-section-title {
    font-size: 21px;
    font-weight: 500;
    border-bottom: solid 1px #ddd;
    padding-bottom: 5px;
    margin-top: 10px;
}

.df-section-desc {
    font-size: 12pt;
    color: #606060;
    padding-bottom: 15px;
}

#DFEditForm .df-section-desc {
    padding-left: 0;
}

.DFSectionContents {
    padding-bottom: 5px;
}

.df-inline-btn {
    display: inline-block;
    padding-left: 15px;
    margin-bottom: 15px;
}

/*.dfRegion,
.dfSection {
    padding-left: 0;
    padding-right: 0;
}*/

/*.address-form-group {
    padding: 0;
}*/

/*.address-form-group .{
    margin-bottom: 10px;
}

.address-form-group ..{
    margin-bottom: 0;
}*/

/*.{
    padding-left: 0;
    padding-right: 0;
}*/

/* --------------------------------------------------------------------
    ALERTS
-------------------------------------------------------------------- */
/*.alert {
    display: table;
    width: 100%;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 3px 15px 0 #aaa;
    border-radius: px;
    border: none;
}

.alert-status {
    display: table-cell;
    width: 40px;
    background-repeat: no-repeat;
    background-position: center center;
}

.alert-content {
    display: table-cell;
    background: #ffffff;
    color: #555555;
    padding: 15px;
}*/

.alert :last-child {
    margin-bottom: 0;
}

/*.alert-danger {
    border-color: #ce6666;
}*/

/*.alert-danger .alert-status {
    background-color: #ce6666;
    background-image: url('../images/alert-danger.png');
    background-size: 5px;
}*/

/*.alert-success {
    border-color: #4bab4b;
}*/

/*.alert-success .alert-status {
    background-size: 23px;
    background-color: #4bab4b;
    background-image: url('../images/alert-success.png');
}*/

/*.alert-warning {
    border-color: #ffd433;
}*/

/*.alert-warning .alert-status {
    background-size: 25px;
    background-color: #ffd433;
    background-image: url('../images/alert-warning.png');
}

.alert h1 {
    font-size: 2em;
    margin: 5px auto 15px auto;
}*/

/*.alert-info {
    border-color: #50b2e4;
}

.alert-info .alert-status {
    background-size: 24px;
    background-color: #50b2e4;
    background-image: url('../images/info2.png');
}*/
/* --------------------------------------------------------------------
    NAVIGATION
-------------------------------------------------------------------- */
.navbar-default {
    background-color: #ffffff;
    border-color: #cccccc;
    border-right: none;
    border-left: none;
    border-radius: 0;
}

.navbar-default .navbar-nav > li > a {
    color: #444444;
}

.navbar-default .navbar-nav > li > a:hover {
    background: #eeeeee;
    color: #000000;
}

.nav.navbar-nav {
    margin: 0;
}

.navbar-toggle {
    border: none;
}

/* --------------------------------------------------------------------
    PREVIEW
-------------------------------------------------------------------- */

.preview_container {
    border-radius: 8px;
}

.navigation_placeholder,
.button_placeholder {
    /*border: 2px dashed #bbbbbb;*/
    background: #f4f4f4;
    color: #aaaaaa;
    text-align: center;
    vertical-align: middle;
    border-radius: 4px;
    font-size: 16px;
}

.navigation_placeholder {
    height: 200px;
    margin-bottom: 20px;
    padding-top: 85px;
}

.button_placeholder {
    padding: 6px 12px;
    display: inline-block;
    margin-bottom: 3px;
    border: 1px solid transparent;
}

/* --------------------------------------------------------------------
    INDEX - DIRECTORY
-------------------------------------------------------------------- */

#formEditTable td {
    vertical-align: middle;
}

/* --------------------------------------------------------------------
    MEDIA QUERIES
-------------------------------------------------------------------- */

@media (max-width: 575px) {
    .df-inline-btn {
        display: block;
        width: 100%;
        padding: 0 15px;
    }
    .df-inline-btn .btn {
        width: 100%;
    }
}

@media (max-width: 767px) {
    .pull-right-sm {
        text-align: right;
        margin-bottom: 5px;
    }
}

@media (min-width: 768px) {
    .dl-horizontal-small dt {
        width: 80px;
        text-align: left;
    }
    .dl-horizontal-small dd {
        margin-left: 100px;
    }
}

.pull-right-sm {
    float: right;
}

.checkbox-withchild {
    margin-top: 2px;
    margin-bottom: 4px;
}

.checkbox-withchild input[type="radio"],
.checkbox-withchild input[type="checkbox"] {
    margin-top: 0px;
}

.no-margin {
    margin: 0px;
    padding: 0px;
}

.dfForEachItem {
    border: 1px solid transparent;
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 10px 0;
    background: #f4f4f4;
    clear: both;
}

.dfForEachItem .dfForEachItem {
    background: #ffffff;
}

.dfForEachItem .dfForEachItem .dfForEachItem {
    background: #f4f4f4;
}

.dfForEachItem .dfForEachItem .dfForEachItem .dfForEachItem {
    background: #ffffff;
}

.dfForEachItem .no-margin.form-group {
    margin-bottom: 0px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.dfForEachItem_RemoveHover {
    border-color: #bbb;
    border-width: 1px;
    border-style: solid;
}

.dfForEachItem .dfNavRemoveButton {
    position: absolute;
    right: 0;
    top: 0;
    padding: 4px 8px;
}

.dfForEachItem_RemoveHover .dfNavRemoveButton {
    border-radius: 0 2px 0 4px;
}

.btn-file {
    position: relative;
    overflow: hidden;
    width: 100%;
}

.btn-file input[type="file"] {
    display: inline-block;
    background: white;
    color: black;
}

.dfNavButton.btn-file {
    padding: 0;
}

.btn-file input[type="file"],
.dfFileInfo {
    position: static;
    height: auto;
    width: 100%;
    border: 2px dashed #aaaaaa;
    border-radius: 5px;
    font-size: 14px;
    background: none;
    opacity: 1;
    padding: 15px;
}

.dfFileInfo .file-input-path {
    padding: 6px;
}

header,
footer,
nav,
section {
    display: block;
}

/* Styles for basic forms
-----------------------------------------------------------*/

#feedbackForm fieldset {
    border: none;
    padding: 0;
    margin: 0;
}

html.bootstrap-legacy textarea,
html.bootstrap-5 textarea.form-control {
    min-height: 75px;
}

.editor-label {
    margin: 1em 0 0 0;
}

.editor-field {
    margin: 0.5em 0 0 0;
}

table th a,
table th a:hover {
    color: #444;
    text-decoration: none;
}

.headerSortDown span:after,
.headerSortUp span:after,
.header span:after {
    display: inline-block;
    margin-top: -2px;
    vertical-align: middle;
    width: 10px;
    height: 14px;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    content: "";
    margin-left: 3px;
}

.header.headerSortDown span:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.header.headerSortUp span:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.header span:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

/* Styles for validation helpers
-----------------------------------------------------------*/

.field-validation-valid {
    display: none;
}

.input-validation-error {
    border: 1px solid #f00;
    background-color: #fee;
}

.validation-summary-errors {
    font-weight: bold;
    color: #f00;
}

.validation-summary-valid {
    display: none;
}

.FormSubmission {
    color: #3f3c2d;
    display: block;
    border: 1px solid transparent;
    border-radius: 5px;
    padding: 10px 10px 10px 80px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: 10px center;
    background-repeat: no-repeat;
}

.FormSubmission .text-info {
    color: #3f3c2d;
    text-decoration: none !important;
}

.fsDisabled .text-info {
    color: #606060;
}

a.FormSubmission:hover,
a.FormSubmission:active,
a.FormSubmission:visited {
    color: #3f3c2d;
    text-decoration: none;
}
a.FormSubmission:hover h4,
a.FormSubmission:active h4 {
    color: #3f3c2d;
    text-decoration: none;
}

a.FormSubmission:hover,
a.FormSubmission:active {
    border-color: #ccc;
    border-radius: 5px;
}

a.fsAlert {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.fsDisabled {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    color: #606060;
}

.fsNew {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.fsComplete {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

div.ReviewPane-Container {
    width: 820px;
    height: 200px;
    padding: 0;
    position: fixed;
    bottom: 0;
    left: calc(50% - 410px);
    z-index: 9;
}

div.ReviewPane-ResizeContainer {
    height: 100%;
    width: 100%;
    min-width: 600px;
    min-height: 200px;
}

div.ReviewPane {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    -moz-border-radius: 10px;
    border-radius: 10px;
}

div.rpTitle {
    position: absolute;
    top: 10px;
    left: 10px;
    border-top-left-radius: 10px;
    background-color: rgb(20, 124, 61);
    background-color: rgba(20, 124, 61, 0.8);
    color: #ffffff;
    width: 150px;
    height: 80px;
    padding-top: 15px;
    padding-left: 25px;
    font-weight: bold;
    font-size: 14pt;
}

a.rpEdit,
a.rpLog {
    display: block;
    position: absolute;
    height: 40px;
    width: 160px;
    cursor: pointer;
    color: #cccccc;
    background: none;
    /*border-top-left-radius:10px;
    border-bottom-left-radius:10px;*/
    padding-left: 5px;
    padding-top: 10px;
    font-weight: bold;
    text-decoration: none;
}

a.rpEdit:hover,
a.rpLog:hover {
    color: #ffffff;
    text-decoration: none;
}

a.rpActive,
a.rpActive:hover,
a.rpActive:active,
a.rpActive:visited {
    background-color: rgba(255, 255, 255) !important;
    background-color: rgba(255, 255, 255, 1) !important;
    color: #000000 !important;
    cursor: default !important;
}

a.rpEdit {
    top: 100px;
    left: 10px;
}

a.rpLog {
    top: 150px;
    left: 10px;
    border-bottom-left-radius: 10px;
}

div.rpEdit,
div.rpEdit > .row,
div.rpEdit .comment-pane,
div.rpEdit .comment-pane .form-group,
div.rpEdit .comment-pane textarea {
    height: 100%;
}

div.rpEdit .comment-pane,
div.rpEdit .other-pane {
    float: left;
    padding: 10px;
}
div.rpEdit .comment-pane {
    width: 66%;
    width: calc(100% - 200px);
}
div.rpEdit .other-pane {
    width: 33%;
    width: calc(200px);
}

div.rpLog,
div.rpEdit {
    position: absolute;
    top: 10px;
    left: 170px;
    width: 640px;
    width: calc(100% - 180px);
    height: 180px;
    height: calc(100% - 20px);
    background-color: rgba(255, 255, 255);
    background-color: rgba(255, 255, 255, 1);
    color: #000000;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    display: none;
    padding: 10px;
}

div.rpActive {
    display: block;
}

div.rpLog {
    padding: 10px;
}

div.rpLogScroll {
    overflow-y: scroll;
    height: 100%;
    padding-right: 20px;
}

div.rpLogEntry {
    padding-bottom: 10px;
}

span.rpLogDate {
    display: inline-block;
    font-weight: bold;
    color: #720000;
    width: 90px;
}

span.rpLogBy {
    display: inline-block;
    font-weight: bold;
    width: 250px;
}

div.rpLogEntry p {
    display: block;
    border-top: solid 1px #cccccc;
}

div.dfFormSearch_checkbox {
    margin-top: 0px;
    margin-bottom: 3px;
}

div.dfSearchSection {
    border-radius: 4px;
    border: solid 1px #ccc;
    margin-bottom: 20px;
}

div.dfSearchSectionHeader {
    border-radius: 4px 4px 0 0;
    background-color: #f5f5f5;
    border: solid 1px #ccc;
    padding: 6px 10px 2px 10px;
    cursor: pointer;
    margin-top: -1px;
    margin-left: -1px;
    margin-right: -1px;
}
div.dfSearchSectionHeader label,
div.dfSearchSectionHeader input {
    cursor: pointer;
}
div.dfSearchSection-Active div.dfSearchSectionHeader label,
div.dfSearchSection-Active div.dfSearchSectionHeader input {
    cursor: default;
}

div.dfSearchSection-Active div.dfSearchSectionHeader {
    border-color: transparent;
}

div.dfSearchSectionContents {
    padding: 10px;
    border-color: #ccc;
}

div.dfSearchSection-Active div.dfSearchSectionHeader {
    background-color: #337ab7;
    color: white;
}

div.dfSearchSection div.checkbox label {
    cursor: not-allowed;
}

div.dfSearchSection-Active div.checkbox label {
    cursor: pointer;
}

a.FormSearchResultRow,
a.FormSearchResultRow:active,
a.FormSearchResultRow:hover,
a.FormSearchResultRow:link,
a.FormSearchResultRow:visited,
div.FormSearchResultRow,
div.FormSearchResultRowContainer {
    display: block;
    color: inherit;
    margin: 0;
    padding: 3px 0;
    border: solid 1px transparent;
    border-radius: 0;
}

div.FormSearchResultRowContainer {
    border-left: 1px solid #ddd;
}

a.FormSearchResultRow.AltRow,
div.FormSearchResultRow.AltRow,
div.FormSearchResultRowContainer.AltRow {
    background-color: #f5f5f5;
}

a.FormSearchResultLink,
a.FormSearchResultLink:active,
a.FormSearchResultLink:hover,
a.FormSearchResultLink:link,
a.FormSearchResultLink:visited {
    display: block;
    border: solid 1px transparent;
    border-radius: 4px;
    -moz-border-radius: 4px;
    text-decoration: none;
    color: inherit;
}

a.FormSearchResultRow:active,
a.FormSearchResultRow:hover {
    border-right-color: #147c3d;
    border-left-color: #147c3d;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}

.SmallMargin-Left {
    padding-left: 5px !important;
}
.SmallMargin-Right {
    padding-right: 5px !important;
}

.FormSearchResultDetailRow {
    font-size: 10pt !important;
}

.form-control-static {
    padding-top: 0px !important;
    min-height: 20px !important;
    margin-bottom: 0;
}

.control-label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 600;
}

p.single-space {
    margin-bottom: 2px !important;
}

div.results-footer {
    border-top: solid 1px #ddd;
    padding-bottom: 10px;
}

div.df-page-sub.text-danger {
    color: #b94a48 !important;
}

.modal-footer > :not(:last-child) {
    margin-right: 0;
}

.public_pages_toggle {
    display: table;
    margin-right: 0;
}

.pages_text {
    display: table-cell;
    padding-right: 10px;
    vertical-align: middle;
    color: #666;
}

.pages_icon_bars {
    display: table-cell;
    vertical-align: middle;
}

#pageNavigation {
    padding: 0;
    border: none;
}

/* --------------------------------------------------------------------
    FOOTER
-------------------------------------------------------------------- */
.footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    width: 100%;
    background: #ffffff;
    padding: 0 15px;
    margin-top: 0;
    border-top: 1px solid #dddddd;
    /*Having issues with sticky footer, hiding for now*/
    /*display: none;*/
}

.footer #footerLinks {
    width: 100%;
    text-align: center;
    float: left;
}

.footer ul {
    list-style: none;
    margin: 0;
    text-align: center;
    width: auto;
    padding: 0;
    margin: 0 auto;
}

.footer ul li {
    display: inline-block;
}

.footer ul li a,
footer ul li a:visited,
footer ul li a:link {
    font-size: 11px;
    color: #6e9699;
    text-decoration: none;
    padding: 1.5em 0.5em;
    display: inline-block;
    letter-spacing: 0.5px;
    margin: 0;
    width: auto;
    text-transform: uppercase;
}

.footer ul li a:hover {
    background: #eee;
    color: #6e9699;
    text-decoration: underline;
}

.footer img {
    float: right;
    height: 40px;
    width: auto;
    margin-top: 3px;
    margin-right: 0;
    margin-bottom: 0;
    padding: 0;
    border: none;
    bottom: 0;
}

@media (max-width: 767px) {
    body {
        padding-bottom: 0;
    }

    .footer {
        position: static;
        height: auto;
        display: block;
        background: #fff;
        margin: auto;
        padding-top: 15px;
        padding-bottom: 15px;
        margin-top: 30px;
    }

    .footer ul li {
        display: block;
    }

    .footer ul li a,
    footer ul li a:visited,
    footer ul li a:link {
        width: 100%;
        padding: 0;
    }

    .footer ul li a:hover {
        background: none;
    }

    .footer img {
        float: none;
        margin: auto;
    }

    /*.DFPageHeadingCnt {
        padding-left: 0;
        padding-right: 0;
        margin-left: 15px;
        margin-right: 15px;
    }*/

    /*.df-page-title {
        display:block;
        border-left: none;
        padding-left: 0;
    }*/

    /*.DFPageContent {
        margin-left: 0;
        margin-right: 0;
        padding-top: 0;
        padding: 0;
    }*/

    .df-public-nav {
    }

    .df-public-nav .list-group-item {
        padding-top: 5px;
        padding-bottom: 5px;
        transition: all ease 0.15s;
    }

    .container-narrow {
        padding-left: 15px;
        padding-right: 15px;
    }

    .DFFormWrapper {
        margin-left: -15px;
        margin-right: -15px;
    }

    .masthead {
        height: auto;
    }

    .masthead_img_div {
        width: 100%;
        text-align: center;
        height: 50px;
        float: none;
    }

    .masthead img {
        height: 100%;
    }

    .masthead_title_div {
        float: none;
        text-align: center;
        height: auto;
    }

    .masthead .agency_name {
        margin-top: 5px;
        line-height: 1;
        font-size: 24px;
    }

    .masthead .app_name {
        line-height: 1;
        font-size: 18px;
        margin-top: 3px;
    }
}

@media (min-width: 768px) {
    .public_pages_toggle {
        display: none;
    }

    .df-public-nav .navbar {
        border: none;
    }

    /* .df-previous-btn {
        float: left;
    } */

    .btn + .df-save-and-continue-btn {
        float: right;
    }
}
`, "",{"version":3,"sources":["webpack://./styles/DFStyle_Master.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;2DAC2D;AAC3D;;;;IAII,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,wBAAwB;AAC5B;AACA,qDAAqD;;AAErD;;EAEE;AACF;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;EAEE;;AAEF;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;AACpB;AACA;;;;;;;;;;;;IAYI,kBAAkB;IAClB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,yDAA8C;IAC9C,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;;IAEI,yDAA8C;IAC9C,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;;IAEI,yDAAkD;IAClD,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;IAEI,+BAA+B;IAC/B,yDAAsD;IACtD,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;;EAEE;;AAEF;;EAEE;;AAEF;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;;;IAII,gBAAgB;IAChB,UAAU;AACd;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA,qBAAqB;AACrB;IACI,cAAc;IACd,iBAAiB;IACjB,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;;EAOE;;AAEF;;;;;;;;;;;;EAYE;;AAEF;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;;EAIE;;AAEF;;EAEE;;AAEF;;;;;;EAME;;AAEF;;;EAGE;;AAEF;;sEAEsE;AACtE;;;;;;;;;;;;;;;;;;;;;;EAsBE;;AAEF;IACI,gBAAgB;AACpB;;AAEA;;EAEE;;AAEF;;;;EAIE;;AAEF;;EAEE;;AAEF;;;;EAIE;;AAEF;;EAEE;;AAEF;;;;;;;;;EASE;;AAEF;;;;;;;;EAQE;AACF;;sEAEsE;AACtE;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;;sEAEsE;;AAEtE;IACI,kBAAkB;AACtB;;AAEA;;IAEI,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;;sEAEsE;;AAEtE;IACI,sBAAsB;AAC1B;;AAEA;;sEAEsE;;AAEtE;IACI;QACI,cAAc;QACd,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;4DAC4D;;AAE5D;IACI,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yDAAmD;AACvD;;AAEA;IACI,yDAAqD;AACzD;;AAEA;IACI,yDAAiD;AACrD;;AAEA;4DAC4D;;AAE5D;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;IAC5B,yDAA+C;IAC/C,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;AACA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yDAAkD;AACtD;;AAEA;IACI,yDAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,0DAA8C;AAClD;;AAEA;IACI,0DAAmD;AACvD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;IACd,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,4BAA4B;IAC5B,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB;oCACgC;IAChC,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;IAII,gDAAgD;IAChD,mDAAmD;IACnD,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,UAAU;IACV,UAAU;IACV,+BAA+B;AACnC;;AAEA;;;;;IAKI,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,aAAa;AACjB;AACA;IACI,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,qCAAqC;IACrC,wCAAwC;IACxC,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;IAChC,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;;;;IAOI,cAAc;IACd,cAAc;IACd,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;;;IAKI,cAAc;IACd,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;;sEAEsE;AACtE;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,mDAAmD;IACnD,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,SAAS;AACb;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;;;QAGI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;;;;MAKE;;IAEF;;;;MAIE;;IAEF;;;;;MAKE;;IAEF;IACA;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;;OAEG;;IAEH;QACI,YAAY;IAChB;AACJ","sourcesContent":["html {\n    min-height: 100%;\n    position: relative;\n}\n\ninput.list-group-item {\n    text-align: left;\n    width: 100%;\n}\n\n.form-control-static {\n    height: auto;\n    min-height: 34px;\n    font-weight: normal;\n}\n\n.has-error label.dfRequired,\n.has-error legend.dfRequired {\n    color: #b94a48;\n}\n\n.nested-row.form-group-child {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n}\n\n.nested-row,\n.nested-row.form-group-child .form-group-child {\n    margin: 0 !important;\n}\n\n.help-button {\n    padding: 0 2px;\n    font-size: 14px;\n}\n\n/*label.dfRequired + .checkbox:only-of-type label:after,\n    label.dfRequired + .checkbox:only-of-type label:after,*/\nlabel.dfRequired:after,\nlegend.dfRequired:after,\n[data-val-required] + .checkbox:only-of-type label:after,\n[data-val-required] + .checkbox-inline:only-of-type:after {\n    position: relative;\n    content: \"*\";\n    color: #b94a48;\n    font-size: 1.4em;\n    font-weight: normal;\n    line-height: 0.8ex;\n    vertical-align: middle;\n}\n\nlabel.dfRequired + [data-val-required] + .checkbox:only-of-type label:after {\n    display: none;\n    content: \"\";\n}\n\n.checkbox:only-of-type [type=\"checkbox\"][data-val-required]:before,\n.checkbox-inline:only-of-type [type=\"checkbox\"][data-val-required]:before {\n    display: none !important;\n}\n/*TODO: Add required asterisk to form labels instead*/\n\n/*div.dfCompositeControlErrorMessage span{\n    display:none;\n}*/\ndiv.dfCompositeControlErrorMessage :first-child {\n    color: #0000ff;\n}\n\ndiv.child-error .highlight-on-child-error {\n    color: #b94a48;\n}\n\n.dfCompositControlChildMargin {\n    margin-top: 5px;\n}\n\n.dfHideBlock {\n    display: none;\n}\n\n.dfHidden {\n    display: none;\n}\n\n.masthead {\n    width: 100%;\n    height: 100px;\n    padding: 15px;\n    background-image: none;\n    background-color: #ffffff;\n}\n\n.masthead {\n    width: 100%;\n    height: 100px;\n    padding: 15px;\n    background-image: none;\n    background-color: #ffffff;\n    z-index: 2;\n}\n\n.masthead_img_div {\n    float: left;\n    height: 70px;\n    width: auto;\n    margin-right: 15px;\n}\n\n.masthead img {\n    height: 70px;\n}\n\n.masthead_title_div {\n    float: left;\n    height: 70px;\n}\n\n.masthead span {\n    display: block;\n    margin-left: 0;\n    color: #444444;\n    font-weight: normal;\n}\n\n.masthead .agency_name {\n    font-size: 30px;\n    margin-top: -3px;\n}\n\n.masthead .app_name {\n    font-size: 24px;\n    margin-top: -5px;\n}\n\n.form-group-child {\n    margin-bottom: 10px;\n    /*padding:0;*/\n}\n\n/*.form-group .form-group:not(.form-group-child) {\n    margin-bottom: 0;\n}*/\n\n.dfShowBlock {\n    display: block;\n}\n\ndiv.child-error .child-error-message {\n    display: block;\n    width: 100%;\n    text-align: left;\n    font-style: italic;\n    color: #b94a48;\n}\n\n.field-validation-error {\n    display: block;\n    width: 100%;\n    text-align: left;\n    font-style: italic;\n    font-size: 13px;\n    font-weight: 500;\n    color: #b94a48;\n    margin-top: 3px;\n}\n\n/* For null page statuses */\n#PageNavigation .list-group-item {\n    background-repeat: no-repeat;\n    width: 100%;\n    text-align: left;\n}\na.dfPageLink_NotStarted,\nbutton[type=\"submit\"].dfPageLink_NotStarted,\na.dfPageLink_InProgress,\nbutton[type=\"submit\"].dfPageLink_InProgress,\na.dfPageLink_Invalid,\nbutton[type=\"submit\"].dfPageLink_Invalid,\na.dfPageLink_Complete,\nbutton[type=\"submit\"].dfPageLink_Complete,\na.dfPageLink_Disabled,\nbutton[type=\"submit\"].dfPageLink_Disabled,\na.dfPageLink_Saving,\nbutton[type=\"submit\"].dfPageLink_Saving {\n    padding-left: 30px;\n    background-repeat: no-repeat;\n    width: 100%;\n    text-align: left;\n}\n\na.dfPageLink_NotStarted,\nbutton[type=\"submit\"].dfPageLink_NotStarted {\n    background-position: 4px 3px;\n}\n\na.dfPageLink_Complete,\nbutton[type=\"submit\"].dfPageLink_Complete {\n    background-image: url(\"../images/success.png\");\n    background-size: 17px;\n    background-position: 7px center;\n}\n\na.dfPageLink_Invalid,\nbutton[type=\"submit\"].dfPageLink_Invalid {\n    background-image: url(\"../images/warning.png\");\n    background-size: 17px;\n    background-position: 7px center;\n}\n\na.dfPageLink_InProgress,\nbutton[type=\"submit\"].dfPageLink_InProgress {\n    background-image: url(\"../images/in_progress.png\");\n    background-size: 10px;\n    background-position: 11px center;\n    background-color: #ddd !important;\n    color: #444 !important;\n    border-color: #bbb !important;\n}\n\na.dfPageLink_Saving,\nbutton[type=\"submit\"].dfPageLink_Saving {\n    background-position: 7px center;\n    background-image: url(\"../images/Spinner-1s-16px.gif\");\n    background-size: 18px;\n}\n\n.form-control {\n    color: #333333;\n}\n\n/*.dfGhosted {\n    color: #999999;\n}*/\n\n/*select.dfHasPlaceholder option[value=\"\"], .placeholder {\n    color: #aaaaaa;\n}*/\n\n.form-control::-webkit-input-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n\n.form-control::-moz-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n\n.form-control::-ms-input-placeholder {\n    color: #999999;\n    opacity: 1;\n}\n\n.form-control::placeholder {\n    color: #999999;\n    opacity: 1;\n}\n\n#DataSourceTable,\n.table-datasource {\n    background: #ffffff;\n    margin-bottom: 0;\n}\n\n#DataSourceTable th,\n#DataSourceTable td,\n.table-datasource th,\n.table-datasource td {\n    min-width: 200px;\n    padding: 0;\n}\n\n#DataSourceTable th .form-control,\n.table-datasource th .form-control {\n    background: none;\n}\n\n#DataSourceTable .btn,\n.table-datasource .btn {\n    margin: 0;\n    width: 100%;\n    border-color: transparent;\n    border-radius: 0;\n}\n\n#DataSourceTable .input-group,\n.table-datasource .input-group {\n    flex-wrap: nowrap;\n}\n\n#DataSourceTable .form-control,\n.table-datasource .form-control {\n    border-radius: 0;\n    border-color: transparent;\n    background: none;\n}\n\n#DataSourceTable .form-control:focus,\n.table-datasource .form-control:focus {\n    border-color: dodgerblue;\n}\n\n.btn-delete-hovered {\n    background: #eeeeee;\n}\n\n#DataSourceTable .btn.btn-add-col,\n.table-datasource .btn.btn-add-col {\n    font-size: 18px;\n    padding: 3px;\n}\n\n.data-source-preview {\n    float: right;\n    border: 1px solid #dddddd;\n    border-radius: 4px;\n    padding: 6px 12px;\n    background: #eeeeee;\n}\n\n.add-col {\n    min-width: 0 !important;\n    width: 60px;\n}\n\n/* Custom container */\n.container-narrow {\n    margin: 0 auto;\n    max-width: 1140px;\n    padding: 20px 30px 15px 30px;\n    border: 1px solid #dddddd;\n    background: #ffffff;\n    border-radius: 8px;\n}\n\n.container-narrow > hr {\n    margin: 30px 0;\n}\n\n/*.DFPageHeadingCnt {\n    padding: 15px;\n    display: block;\n    margin-bottom: 30px;\n    border-bottom: solid 1px #dddddd;\n     background: #ffffff;\n    margin-top: 0;\n}*/\n\n/*.DFPageHeading {\n    font-size: 16pt;\n    font-weight: bold;\n    display: block;\n    padding-left: 5px;\n    padding-bottom:2px;\n    margin-bottom:2px;\n    margin-top:0;\n      border-color: #dddddd;\n    margin-left: 0;\n    padding-left: 0;\n    font-size: 24px;\n}*/\n\n.DFPageContent {\n    background: #ffffff;\n}\n\n.df-page-sub {\n    font-size: 12pt;\n    color: #606060;\n    padding-left: 5px;\n    padding-bottom: 15px;\n}\n\n.DFPageContent {\n    padding: 30px 15px;\n    padding-top: 0;\n}\n\n.df-page-title {\n    display: block;\n    margin-top: 4px;\n    border-bottom: 1px solid #dee2e6;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n}\n\n.DFSectionHeading {\n    padding-bottom: 15px;\n}\n\n.df-section-title {\n    font-size: 21px;\n    font-weight: 500;\n    border-bottom: solid 1px #ddd;\n    padding-bottom: 5px;\n    margin-top: 10px;\n}\n\n.df-section-desc {\n    font-size: 12pt;\n    color: #606060;\n    padding-bottom: 15px;\n}\n\n#DFEditForm .df-section-desc {\n    padding-left: 0;\n}\n\n.DFSectionContents {\n    padding-bottom: 5px;\n}\n\n.df-inline-btn {\n    display: inline-block;\n    padding-left: 15px;\n    margin-bottom: 15px;\n}\n\n/*.dfRegion,\n.dfSection {\n    padding-left: 0;\n    padding-right: 0;\n}*/\n\n/*.address-form-group {\n    padding: 0;\n}*/\n\n/*.address-form-group .{\n    margin-bottom: 10px;\n}\n\n.address-form-group ..{\n    margin-bottom: 0;\n}*/\n\n/*.{\n    padding-left: 0;\n    padding-right: 0;\n}*/\n\n/* --------------------------------------------------------------------\n    ALERTS\n-------------------------------------------------------------------- */\n/*.alert {\n    display: table;\n    width: 100%;\n    padding: 0;\n    overflow: hidden;\n    box-shadow: 0 3px 15px 0 #aaa;\n    border-radius: px;\n    border: none;\n}\n\n.alert-status {\n    display: table-cell;\n    width: 40px;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n.alert-content {\n    display: table-cell;\n    background: #ffffff;\n    color: #555555;\n    padding: 15px;\n}*/\n\n.alert :last-child {\n    margin-bottom: 0;\n}\n\n/*.alert-danger {\n    border-color: #ce6666;\n}*/\n\n/*.alert-danger .alert-status {\n    background-color: #ce6666;\n    background-image: url('../images/alert-danger.png');\n    background-size: 5px;\n}*/\n\n/*.alert-success {\n    border-color: #4bab4b;\n}*/\n\n/*.alert-success .alert-status {\n    background-size: 23px;\n    background-color: #4bab4b;\n    background-image: url('../images/alert-success.png');\n}*/\n\n/*.alert-warning {\n    border-color: #ffd433;\n}*/\n\n/*.alert-warning .alert-status {\n    background-size: 25px;\n    background-color: #ffd433;\n    background-image: url('../images/alert-warning.png');\n}\n\n.alert h1 {\n    font-size: 2em;\n    margin: 5px auto 15px auto;\n}*/\n\n/*.alert-info {\n    border-color: #50b2e4;\n}\n\n.alert-info .alert-status {\n    background-size: 24px;\n    background-color: #50b2e4;\n    background-image: url('../images/info2.png');\n}*/\n/* --------------------------------------------------------------------\n    NAVIGATION\n-------------------------------------------------------------------- */\n.navbar-default {\n    background-color: #ffffff;\n    border-color: #cccccc;\n    border-right: none;\n    border-left: none;\n    border-radius: 0;\n}\n\n.navbar-default .navbar-nav > li > a {\n    color: #444444;\n}\n\n.navbar-default .navbar-nav > li > a:hover {\n    background: #eeeeee;\n    color: #000000;\n}\n\n.nav.navbar-nav {\n    margin: 0;\n}\n\n.navbar-toggle {\n    border: none;\n}\n\n/* --------------------------------------------------------------------\n    PREVIEW\n-------------------------------------------------------------------- */\n\n.preview_container {\n    border-radius: 8px;\n}\n\n.navigation_placeholder,\n.button_placeholder {\n    /*border: 2px dashed #bbbbbb;*/\n    background: #f4f4f4;\n    color: #aaaaaa;\n    text-align: center;\n    vertical-align: middle;\n    border-radius: 4px;\n    font-size: 16px;\n}\n\n.navigation_placeholder {\n    height: 200px;\n    margin-bottom: 20px;\n    padding-top: 85px;\n}\n\n.button_placeholder {\n    padding: 6px 12px;\n    display: inline-block;\n    margin-bottom: 3px;\n    border: 1px solid transparent;\n}\n\n/* --------------------------------------------------------------------\n    INDEX - DIRECTORY\n-------------------------------------------------------------------- */\n\n#formEditTable td {\n    vertical-align: middle;\n}\n\n/* --------------------------------------------------------------------\n    MEDIA QUERIES\n-------------------------------------------------------------------- */\n\n@media (max-width: 575px) {\n    .df-inline-btn {\n        display: block;\n        width: 100%;\n        padding: 0 15px;\n    }\n    .df-inline-btn .btn {\n        width: 100%;\n    }\n}\n\n@media (max-width: 767px) {\n    .pull-right-sm {\n        text-align: right;\n        margin-bottom: 5px;\n    }\n}\n\n@media (min-width: 768px) {\n    .dl-horizontal-small dt {\n        width: 80px;\n        text-align: left;\n    }\n    .dl-horizontal-small dd {\n        margin-left: 100px;\n    }\n}\n\n.pull-right-sm {\n    float: right;\n}\n\n.checkbox-withchild {\n    margin-top: 2px;\n    margin-bottom: 4px;\n}\n\n.checkbox-withchild input[type=\"radio\"],\n.checkbox-withchild input[type=\"checkbox\"] {\n    margin-top: 0px;\n}\n\n.no-margin {\n    margin: 0px;\n    padding: 0px;\n}\n\n.dfForEachItem {\n    border: 1px solid transparent;\n    margin-bottom: 15px;\n    border-radius: 4px;\n    padding: 10px 0;\n    background: #f4f4f4;\n    clear: both;\n}\n\n.dfForEachItem .dfForEachItem {\n    background: #ffffff;\n}\n\n.dfForEachItem .dfForEachItem .dfForEachItem {\n    background: #f4f4f4;\n}\n\n.dfForEachItem .dfForEachItem .dfForEachItem .dfForEachItem {\n    background: #ffffff;\n}\n\n.dfForEachItem .no-margin.form-group {\n    margin-bottom: 0px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.dfForEachItem_RemoveHover {\n    border-color: #bbb;\n    border-width: 1px;\n    border-style: solid;\n}\n\n.dfForEachItem .dfNavRemoveButton {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: 4px 8px;\n}\n\n.dfForEachItem_RemoveHover .dfNavRemoveButton {\n    border-radius: 0 2px 0 4px;\n}\n\n.btn-file {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n}\n\n.btn-file input[type=\"file\"] {\n    display: inline-block;\n    background: white;\n    color: black;\n}\n\n.dfNavButton.btn-file {\n    padding: 0;\n}\n\n.btn-file input[type=\"file\"],\n.dfFileInfo {\n    position: static;\n    height: auto;\n    width: 100%;\n    border: 2px dashed #aaaaaa;\n    border-radius: 5px;\n    font-size: 14px;\n    background: none;\n    opacity: 1;\n    padding: 15px;\n}\n\n.dfFileInfo .file-input-path {\n    padding: 6px;\n}\n\nheader,\nfooter,\nnav,\nsection {\n    display: block;\n}\n\n/* Styles for basic forms\n-----------------------------------------------------------*/\n\n#feedbackForm fieldset {\n    border: none;\n    padding: 0;\n    margin: 0;\n}\n\nhtml.bootstrap-legacy textarea,\nhtml.bootstrap-5 textarea.form-control {\n    min-height: 75px;\n}\n\n.editor-label {\n    margin: 1em 0 0 0;\n}\n\n.editor-field {\n    margin: 0.5em 0 0 0;\n}\n\ntable th a,\ntable th a:hover {\n    color: #444;\n    text-decoration: none;\n}\n\n.headerSortDown span:after,\n.headerSortUp span:after,\n.header span:after {\n    display: inline-block;\n    margin-top: -2px;\n    vertical-align: middle;\n    width: 10px;\n    height: 14px;\n    background-position: center center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    content: \"\";\n    margin-left: 3px;\n}\n\n.header.headerSortDown span:after {\n    background-image: url(\"../images/headerSortUp.png\");\n}\n\n.header.headerSortUp span:after {\n    background-image: url(\"../images/headerSortDown.png\");\n}\n\n.header span:after {\n    background-image: url(\"../images/headerSort.png\");\n}\n\n/* Styles for validation helpers\n-----------------------------------------------------------*/\n\n.field-validation-valid {\n    display: none;\n}\n\n.input-validation-error {\n    border: 1px solid #f00;\n    background-color: #fee;\n}\n\n.validation-summary-errors {\n    font-weight: bold;\n    color: #f00;\n}\n\n.validation-summary-valid {\n    display: none;\n}\n\n.FormSubmission {\n    color: #3f3c2d;\n    display: block;\n    border: 1px solid transparent;\n    border-radius: 5px;\n    padding: 10px 10px 10px 80px;\n    background-image: url(\"../images/EditForm.png\");\n    background-position: 10px center;\n    background-repeat: no-repeat;\n}\n\n.FormSubmission .text-info {\n    color: #3f3c2d;\n    text-decoration: none !important;\n}\n\n.fsDisabled .text-info {\n    color: #606060;\n}\n\na.FormSubmission:hover,\na.FormSubmission:active,\na.FormSubmission:visited {\n    color: #3f3c2d;\n    text-decoration: none;\n}\na.FormSubmission:hover h4,\na.FormSubmission:active h4 {\n    color: #3f3c2d;\n    text-decoration: none;\n}\n\na.FormSubmission:hover,\na.FormSubmission:active {\n    border-color: #ccc;\n    border-radius: 5px;\n}\n\na.fsAlert {\n    background-image: url(\"../images/ExclaimForm.png\");\n}\n\n.fsDisabled {\n    background-image: url(\"../images/GreyForm.png\");\n    color: #606060;\n}\n\n.fsNew {\n    background-image: url(\"../images/AddForm.png\");\n}\n\n.fsComplete {\n    background-image: url(\"../images/CompleteForm.png\");\n}\n\ndiv.ReviewPane-Container {\n    width: 820px;\n    height: 200px;\n    padding: 0;\n    position: fixed;\n    bottom: 0;\n    left: calc(50% - 410px);\n    z-index: 9;\n}\n\ndiv.ReviewPane-ResizeContainer {\n    height: 100%;\n    width: 100%;\n    min-width: 600px;\n    min-height: 200px;\n}\n\ndiv.ReviewPane {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background-color: rgb(0, 0, 0);\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #ffffff;\n    -moz-border-radius: 10px;\n    border-radius: 10px;\n}\n\ndiv.rpTitle {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    border-top-left-radius: 10px;\n    background-color: rgb(20, 124, 61);\n    background-color: rgba(20, 124, 61, 0.8);\n    color: #ffffff;\n    width: 150px;\n    height: 80px;\n    padding-top: 15px;\n    padding-left: 25px;\n    font-weight: bold;\n    font-size: 14pt;\n}\n\na.rpEdit,\na.rpLog {\n    display: block;\n    position: absolute;\n    height: 40px;\n    width: 160px;\n    cursor: pointer;\n    color: #cccccc;\n    background: none;\n    /*border-top-left-radius:10px;\n    border-bottom-left-radius:10px;*/\n    padding-left: 5px;\n    padding-top: 10px;\n    font-weight: bold;\n    text-decoration: none;\n}\n\na.rpEdit:hover,\na.rpLog:hover {\n    color: #ffffff;\n    text-decoration: none;\n}\n\na.rpActive,\na.rpActive:hover,\na.rpActive:active,\na.rpActive:visited {\n    background-color: rgba(255, 255, 255) !important;\n    background-color: rgba(255, 255, 255, 1) !important;\n    color: #000000 !important;\n    cursor: default !important;\n}\n\na.rpEdit {\n    top: 100px;\n    left: 10px;\n}\n\na.rpLog {\n    top: 150px;\n    left: 10px;\n    border-bottom-left-radius: 10px;\n}\n\ndiv.rpEdit,\ndiv.rpEdit > .row,\ndiv.rpEdit .comment-pane,\ndiv.rpEdit .comment-pane .form-group,\ndiv.rpEdit .comment-pane textarea {\n    height: 100%;\n}\n\ndiv.rpEdit .comment-pane,\ndiv.rpEdit .other-pane {\n    float: left;\n    padding: 10px;\n}\ndiv.rpEdit .comment-pane {\n    width: 66%;\n    width: calc(100% - 200px);\n}\ndiv.rpEdit .other-pane {\n    width: 33%;\n    width: calc(200px);\n}\n\ndiv.rpLog,\ndiv.rpEdit {\n    position: absolute;\n    top: 10px;\n    left: 170px;\n    width: 640px;\n    width: calc(100% - 180px);\n    height: 180px;\n    height: calc(100% - 20px);\n    background-color: rgba(255, 255, 255);\n    background-color: rgba(255, 255, 255, 1);\n    color: #000000;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    display: none;\n    padding: 10px;\n}\n\ndiv.rpActive {\n    display: block;\n}\n\ndiv.rpLog {\n    padding: 10px;\n}\n\ndiv.rpLogScroll {\n    overflow-y: scroll;\n    height: 100%;\n    padding-right: 20px;\n}\n\ndiv.rpLogEntry {\n    padding-bottom: 10px;\n}\n\nspan.rpLogDate {\n    display: inline-block;\n    font-weight: bold;\n    color: #720000;\n    width: 90px;\n}\n\nspan.rpLogBy {\n    display: inline-block;\n    font-weight: bold;\n    width: 250px;\n}\n\ndiv.rpLogEntry p {\n    display: block;\n    border-top: solid 1px #cccccc;\n}\n\ndiv.dfFormSearch_checkbox {\n    margin-top: 0px;\n    margin-bottom: 3px;\n}\n\ndiv.dfSearchSection {\n    border-radius: 4px;\n    border: solid 1px #ccc;\n    margin-bottom: 20px;\n}\n\ndiv.dfSearchSectionHeader {\n    border-radius: 4px 4px 0 0;\n    background-color: #f5f5f5;\n    border: solid 1px #ccc;\n    padding: 6px 10px 2px 10px;\n    cursor: pointer;\n    margin-top: -1px;\n    margin-left: -1px;\n    margin-right: -1px;\n}\ndiv.dfSearchSectionHeader label,\ndiv.dfSearchSectionHeader input {\n    cursor: pointer;\n}\ndiv.dfSearchSection-Active div.dfSearchSectionHeader label,\ndiv.dfSearchSection-Active div.dfSearchSectionHeader input {\n    cursor: default;\n}\n\ndiv.dfSearchSection-Active div.dfSearchSectionHeader {\n    border-color: transparent;\n}\n\ndiv.dfSearchSectionContents {\n    padding: 10px;\n    border-color: #ccc;\n}\n\ndiv.dfSearchSection-Active div.dfSearchSectionHeader {\n    background-color: #337ab7;\n    color: white;\n}\n\ndiv.dfSearchSection div.checkbox label {\n    cursor: not-allowed;\n}\n\ndiv.dfSearchSection-Active div.checkbox label {\n    cursor: pointer;\n}\n\na.FormSearchResultRow,\na.FormSearchResultRow:active,\na.FormSearchResultRow:hover,\na.FormSearchResultRow:link,\na.FormSearchResultRow:visited,\ndiv.FormSearchResultRow,\ndiv.FormSearchResultRowContainer {\n    display: block;\n    color: inherit;\n    margin: 0;\n    padding: 3px 0;\n    border: solid 1px transparent;\n    border-radius: 0;\n}\n\ndiv.FormSearchResultRowContainer {\n    border-left: 1px solid #ddd;\n}\n\na.FormSearchResultRow.AltRow,\ndiv.FormSearchResultRow.AltRow,\ndiv.FormSearchResultRowContainer.AltRow {\n    background-color: #f5f5f5;\n}\n\na.FormSearchResultLink,\na.FormSearchResultLink:active,\na.FormSearchResultLink:hover,\na.FormSearchResultLink:link,\na.FormSearchResultLink:visited {\n    display: block;\n    border: solid 1px transparent;\n    border-radius: 4px;\n    -moz-border-radius: 4px;\n    text-decoration: none;\n    color: inherit;\n}\n\na.FormSearchResultRow:active,\na.FormSearchResultRow:hover {\n    border-right-color: #147c3d;\n    border-left-color: #147c3d;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n}\n\n.SmallMargin-Left {\n    padding-left: 5px !important;\n}\n.SmallMargin-Right {\n    padding-right: 5px !important;\n}\n\n.FormSearchResultDetailRow {\n    font-size: 10pt !important;\n}\n\n.form-control-static {\n    padding-top: 0px !important;\n    min-height: 20px !important;\n    margin-bottom: 0;\n}\n\n.control-label {\n    display: inline-block;\n    max-width: 100%;\n    margin-bottom: 5px;\n    font-weight: 600;\n}\n\np.single-space {\n    margin-bottom: 2px !important;\n}\n\ndiv.results-footer {\n    border-top: solid 1px #ddd;\n    padding-bottom: 10px;\n}\n\ndiv.df-page-sub.text-danger {\n    color: #b94a48 !important;\n}\n\n.modal-footer > :not(:last-child) {\n    margin-right: 0;\n}\n\n.public_pages_toggle {\n    display: table;\n    margin-right: 0;\n}\n\n.pages_text {\n    display: table-cell;\n    padding-right: 10px;\n    vertical-align: middle;\n    color: #666;\n}\n\n.pages_icon_bars {\n    display: table-cell;\n    vertical-align: middle;\n}\n\n#pageNavigation {\n    padding: 0;\n    border: none;\n}\n\n/* --------------------------------------------------------------------\n    FOOTER\n-------------------------------------------------------------------- */\n.footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 50px;\n    width: 100%;\n    background: #ffffff;\n    padding: 0 15px;\n    margin-top: 0;\n    border-top: 1px solid #dddddd;\n    /*Having issues with sticky footer, hiding for now*/\n    /*display: none;*/\n}\n\n.footer #footerLinks {\n    width: 100%;\n    text-align: center;\n    float: left;\n}\n\n.footer ul {\n    list-style: none;\n    margin: 0;\n    text-align: center;\n    width: auto;\n    padding: 0;\n    margin: 0 auto;\n}\n\n.footer ul li {\n    display: inline-block;\n}\n\n.footer ul li a,\nfooter ul li a:visited,\nfooter ul li a:link {\n    font-size: 11px;\n    color: #6e9699;\n    text-decoration: none;\n    padding: 1.5em 0.5em;\n    display: inline-block;\n    letter-spacing: 0.5px;\n    margin: 0;\n    width: auto;\n    text-transform: uppercase;\n}\n\n.footer ul li a:hover {\n    background: #eee;\n    color: #6e9699;\n    text-decoration: underline;\n}\n\n.footer img {\n    float: right;\n    height: 40px;\n    width: auto;\n    margin-top: 3px;\n    margin-right: 0;\n    margin-bottom: 0;\n    padding: 0;\n    border: none;\n    bottom: 0;\n}\n\n@media (max-width: 767px) {\n    body {\n        padding-bottom: 0;\n    }\n\n    .footer {\n        position: static;\n        height: auto;\n        display: block;\n        background: #fff;\n        margin: auto;\n        padding-top: 15px;\n        padding-bottom: 15px;\n        margin-top: 30px;\n    }\n\n    .footer ul li {\n        display: block;\n    }\n\n    .footer ul li a,\n    footer ul li a:visited,\n    footer ul li a:link {\n        width: 100%;\n        padding: 0;\n    }\n\n    .footer ul li a:hover {\n        background: none;\n    }\n\n    .footer img {\n        float: none;\n        margin: auto;\n    }\n\n    /*.DFPageHeadingCnt {\n        padding-left: 0;\n        padding-right: 0;\n        margin-left: 15px;\n        margin-right: 15px;\n    }*/\n\n    /*.df-page-title {\n        display:block;\n        border-left: none;\n        padding-left: 0;\n    }*/\n\n    /*.DFPageContent {\n        margin-left: 0;\n        margin-right: 0;\n        padding-top: 0;\n        padding: 0;\n    }*/\n\n    .df-public-nav {\n    }\n\n    .df-public-nav .list-group-item {\n        padding-top: 5px;\n        padding-bottom: 5px;\n        transition: all ease 0.15s;\n    }\n\n    .container-narrow {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    .DFFormWrapper {\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n\n    .masthead {\n        height: auto;\n    }\n\n    .masthead_img_div {\n        width: 100%;\n        text-align: center;\n        height: 50px;\n        float: none;\n    }\n\n    .masthead img {\n        height: 100%;\n    }\n\n    .masthead_title_div {\n        float: none;\n        text-align: center;\n        height: auto;\n    }\n\n    .masthead .agency_name {\n        margin-top: 5px;\n        line-height: 1;\n        font-size: 24px;\n    }\n\n    .masthead .app_name {\n        line-height: 1;\n        font-size: 18px;\n        margin-top: 3px;\n    }\n}\n\n@media (min-width: 768px) {\n    .public_pages_toggle {\n        display: none;\n    }\n\n    .df-public-nav .navbar {\n        border: none;\n    }\n\n    /* .df-previous-btn {\n        float: left;\n    } */\n\n    .btn + .df-save-and-continue-btn {\n        float: right;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
